import { z } from "zod";

import { emailSchema } from "@/lib/validation";

const requiredString = (message: string) =>
  z.preprocess(
    value => (value === undefined || value === null ? "" : value),
    z.string().refine(value => value.trim().length > 0, { message })
  );

export const createRepresentativeSchema = (requiredMessage: string, invalidEmailMessage: string) =>
  z.looseObject({
    uuid: z.string().optional(),
    first_name: requiredString(requiredMessage),
    last_name: requiredString(requiredMessage),
    email: emailSchema({ required: requiredMessage, invalid: invalidEmailMessage }),
  });
